export const caseStudiesPages = {
  probly: {
    title: "Probly",
    subtitle: "Ein Portrait Image Generator für schnelle, konsistente und hochwertige Visuals",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1516321497487-e288fb19713f?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Ausgangssituation",
        content: `
          Für Probly stand die Frage im Mittelpunkt, wie hochwertige Portraitbilder schneller erzeugt und in einem klaren digitalen Produkt nutzbar gemacht werden können. Ziel war eine Anwendung, die für Nutzer einfach verständlich ist, technisch stabil läuft und den eigentlichen Mehrwert des Produkts klar in den Vordergrund stellt.
        `,
      },
      {
        heading: "Unsere Aufgabe",
        content: `
          Wir haben das Produkt als Softwarelösung gedacht: mit Fokus auf Nutzerfluss, technischer Struktur und einer klaren Oberfläche. Entscheidend war nicht nur die eigentliche Bildgenerierung, sondern auch der Weg dorthin: Upload, Auswahl, Verarbeitung, Ausgabe und eine nachvollziehbare Nutzererfahrung.
        `,
      },
      {
        heading: "Was umgesetzt wurde",
        content: `
          <ul>
            <li>Konzeption einer nutzerfreundlichen Produktstruktur</li>
            <li>Aufbau einer klaren Frontend-Logik für den Bild-Workflow</li>
            <li>Integration der Generierungslogik in eine schlanke Anwendung</li>
            <li>Fokus auf einfache Bedienung, schnelle Interaktion und saubere Ergebnisse</li>
          </ul>
        `,
      },
      {
        heading: "Ergebnis",
        content: `
          Probly zeigt, wie aus einer KI-nahen Idee ein konkretes digitales Produkt werden kann. Der Mehrwert liegt nicht nur in der Bildausgabe selbst, sondern in der Kombination aus verständlichem Produktfluss, technischer Stabilität und einer Oberfläche, die die Nutzung einfach macht.
        `,
      },
    ],
  },
  nodebase: {
    title: "Nodebase",
    subtitle: "Ein Note Creation Tool für strukturierte Wissensarbeit und schnelle Dokumentation",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Ausgangssituation",
        content: `
          Nodebase entstand aus der Anforderung, Informationen schneller zu erfassen, besser zu strukturieren und im Arbeitsalltag nutzbar zu halten. Viele bestehende Tools sind entweder zu allgemein oder zu überladen. Gesucht war eine fokussierte Lösung für saubere Notizerstellung und Wissensorganisation.
        `,
      },
      {
        heading: "Unsere Aufgabe",
        content: `
          Ziel war die Entwicklung eines klaren, produktiven Tools für die Erstellung und Verwaltung von Notizen. Dabei stand im Vordergrund, Inhalte nicht nur abzulegen, sondern so aufzubauen, dass sie später leicht gefunden, erweitert und in Arbeitsprozesse eingebunden werden können.
        `,
      },
      {
        heading: "Was umgesetzt wurde",
        content: `
          <ul>
            <li>Konzeption einer klaren Informations- und Navigationsstruktur</li>
            <li>Aufbau einer Oberfläche für schnelle Notizerstellung</li>
            <li>Strukturierung von Inhalten für bessere Wiederverwendbarkeit</li>
            <li>Fokus auf einfache Bedienung und produktive Wissensarbeit</li>
          </ul>
        `,
      },
      {
        heading: "Ergebnis",
        content: `
          Nodebase zeigt, wie aus einem scheinbar einfachen Tool ein echter Produktivitätsbaustein werden kann. Der Wert liegt in einer klaren Struktur, geringer Reibung bei der Nutzung und einem Setup, das tägliche Wissensarbeit spürbar erleichtert.
        `,
      },
    ],
  },
  "mini-erp": {
    title: "Mini-ERP",
    subtitle:
      "Ein individuell entwickeltes ERP für einen Werkstattbetrieb mit durchgängiger Prozessabbildung",
    date: "2026-03-27",
    image:
      "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?q=80&w=2070&auto=format&fit=crop",
    sections: [
      {
        heading: "Ausgangssituation",
        content: `
          Für einen Werkstattbetrieb bestand die Herausforderung darin, viele operative Abläufe mit allgemeinen Tools, manuellen Listen und nicht optimal passenden Standardsystemen abzubilden. Dadurch entstanden Medienbrüche, unnötiger Abstimmungsaufwand und zu wenig Transparenz über den Gesamtprozess.
        `,
      },
      {
        heading: "Unsere Aufgabe",
        content: `
          Ziel war der Aufbau eines maßgeschneiderten Mini-ERP-Systems, das die tatsächlichen Abläufe der Werkstatt von Anfang bis Ende abbildet. Entscheidend war dabei nicht ein großer Standardumfang, sondern eine Lösung, die genau zu den Anforderungen des Betriebs passt.
        `,
      },
      {
        heading: "Was umgesetzt wurde",
        content: `
          <ul>
            <li>Abbildung der werkstattspezifischen Prozesse in einer zentralen Anwendung</li>
            <li>Unterstützung der Abläufe von Anfrage bis Abschluss</li>
            <li>Strukturierte Verwaltung von Aufträgen, Status und Prozessschritten</li>
            <li>Fokus auf eine einfache Bedienung für den operativen Alltag</li>
          </ul>
        `,
      },
      {
        heading: "Ergebnis",
        content: `
          Das Mini-ERP schafft eine deutlich bessere Übersicht über alle relevanten Vorgänge und reduziert manuelle Nebenarbeit. Die Werkstatt kann ihre Prozesse nun Ende-zu-Ende so steuern, wie sie im Alltag tatsächlich benötigt werden, statt sich an starre Standards anpassen zu müssen.
        `,
      },
    ],
  },
};
